"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("./styled-components");
var Card = function Card(_ref) {
  var children = _ref.children,
    badge = _ref.badge,
    color = _ref.color,
    css = _ref.css;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.PFCard, {
    color: color,
    size: {
      '@initial': 'mobile',
      '@tablet': 'tablet',
      '@desktop': 'desktop'
    },
    css: css
  }, badge && /*#__PURE__*/_react.default.createElement(_styledComponents.Badge, {
    color: color
  }, badge), children);
};
Card.propTypes = {
  children: _propTypes.default.node.isRequired,
  badge: _propTypes.default.string,
  color: _propTypes.default.oneOf(['green', 'blue', 'default']),
  css: _propTypes.default.shape({})
};
Card.defaultProps = {
  badge: '',
  color: 'default',
  css: {}
};
var _default = exports.default = Card;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');